// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__3LbPV","time":"styles_time__ULK1t"};